import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, iif, Observable, Subject } from 'rxjs';
import { takeUntil, tap } from 'rxjs/operators';
import { PolicyService } from '../services/policy.service';

@Injectable({
    providedIn: 'root',
})
export class PrivacyInterceptorService implements HttpInterceptor {
    stopInterceptor$ = new Subject();

    constructor(private policyService: PolicyService) {}
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(req).pipe(
            tap((event) => {
                if (this.isHttpResponseEvent(event)) {
                    this.handleResponse(event as HttpResponse<any>);
                }
                return event;
            }),
            takeUntil(this.stopInterceptor$)
        );
    }

    handleResponse(event) {
        // //console.log(event);
        if (!event.body.tokenParameter) return;
        // //console.log(event.body.tokenParameter.policyReview);
        this.policyService.policyReview.next(event.body.tokenParameter.policyReview);
        this.policyService.policyAccepted = !!(event.body.tokenParameter.policyReview < 2);
        this.policyService.loaded = true;
    }

    isHttpResponseEvent(event: HttpEvent<any>) {
        return event instanceof HttpResponse;
    }
}
